import script from "./FormSuratPernyataanKebenaranDokumen.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSuratPernyataanKebenaranDokumen.vue?vue&type=script&setup=true&lang=js"

import "./FormSuratPernyataanKebenaranDokumen.vue?vue&type=style&index=0&id=71471b68&lang=css"

const __exports__ = script;

export default __exports__